import { capabilities, setModifierManager } from '@ember/modifier';
import { untrack } from '@glimmer/validator';

import type { ModifierLike } from '@glint/template';

interface State {
	element?: HTMLElement;
}

interface Args {
	positional: unknown[];
	named: Record<string, unknown>;
}

type OnChangeFn = (element: HTMLElement) => void;

// Copied functionality from @ember/render-modifiers
// See more at https://github.com/ember-template-lint/ember-template-lint/blob/master/docs/rule/no-at-ember-render-modifiers.md

const DidUpdateModifier = setModifierManager(
	() => ({
		capabilities: capabilities('3.22', { disableAutoTracking: false }),
		createModifier() {
			return { element: null };
		},
		installModifier(state: State, element: HTMLElement, args: Args) {
			// save element into state bucket
			state.element = element;

			// Consume individual properties to entangle tracking.
			// https://github.com/emberjs/ember.js/issues/19277
			// https://github.com/ember-modifier/ember-modifier/pull/63#issuecomment-815908201
			args.positional.forEach(() => {
				// nothing
			});
			Object.values(args.named || {});
		},

		updateModifier(state: State, args: Args) {
			const fn = args.positional[0] as OnChangeFn;

			// Consume individual properties to entangle tracking.
			// https://github.com/emberjs/ember.js/issues/19277
			// https://github.com/ember-modifier/ember-modifier/pull/63#issuecomment-815908201
			args.positional.forEach(() => {
				// nothing
			});
			Object.values(args.named || {});
			untrack(() => {
				fn(state.element!);
			});
		},

		destroyModifier() {
			// nothing
		},
	}),
	class DidUpdateModifierClass {},
);

type Modifier = ModifierLike<{
	Args: { Positional: [handler: (node: HTMLElement) => void, ...positional: unknown[]] };
	Return: void;
}>;

export default DidUpdateModifier as unknown as Modifier;
